import React from 'react';
import moment from 'moment';
import Calendar from '../../common/components/calendar/Calendar';
import withSingleSelection from '../../common/components/calendar/withSingleSelection';
import withLocalized from '../../localization/withLocalized';
import Select from '../../common/components/select/Select';
import { BookingService } from '../../../api/booking-service';
import { TimeList } from './TimeList';
import { LoaderWrapper,  LoaderSVG } from '../../common/components/loader/BlockingLoader'
import { media } from '../../common/components/ui/utils';
import {
  NoAvailableTimes,
  CalendarWrapper,
  CalendarSection,
  CalendarLoaderContainer,
  VirtualCalendarScroller,
  CalendarSelectLabel,
} from '../ui/index';
import {
  ProSelectorActiveBar,
  ProSelectorItemContent,
  ProsSelectorContainer,
  ProsSelectorItem,
  ProsSelectorName
} from './ProSelector';
import colors from '../../common/components/ui/colors';
import { ThemeProvider } from 'styled-components';

const CalendarWithSelection = withSingleSelection(Calendar);

class ProCalendar extends React.Component {

  initialState = {
    month: moment(),
    selectedDate: undefined,
    times: [],
    fieldId: undefined,
    isLoading: true,
    pro: undefined,
    services: undefined,
    fieldServices: undefined,
    selectedService: undefined,
    disabledDates: []
  };

  timesList;

  constructor() {
    super();
    this.state = this.initialState;
    this.bookingService = new BookingService();
  };

  componentWillReceiveProps(nextProps) {
    const {
      pro,
    } = nextProps;

    if (!pro) return;
    if (pro.id === this.props.pro.id) return;

    this.setState({ pro }, () => {

      if (this.state.pro.services) {
        this.setState({ isLoading: true }, () => {
          if (this.props.onCalendarLoadingChange) this.props.onCalendarLoadingChange(this.state.isLoading);
          setTimeout(() => {
            this._fetchServiceData();
          }, 500);
        });
      }
    });
  }

  componentWillMount() {
    const {
      pro,
    } = this.props;

    if (!pro) return;

    this.setState({ pro }, () => {

      if (this.state.pro.services) {
        this.setState({ isLoading: true }, () => {
          if (this.props.onCalendarLoadingChange) this.props.onCalendarLoadingChange(this.state.isLoading);
          setTimeout(() => {
            this._fetchServiceData();
          }, 500);
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isLoading !== prevState.isLoading) {
      if (this.props.onCalendarLoadingChange) this.props.onCalendarLoadingChange(this.state.isLoading);
    }
  }

  _fetchServiceData() {
    this.setState({ isLoading: true}, () => {
      const serviceIds = this.bookingService.parseServiceIdsFromProData(this.state.pro);
      this.bookingService
        .getServices(serviceIds)
        .then(services => {
          this.setState({ services, isLoading: false }, () => {
            try {
              this._proLocationChanged({
                target: {
                  value: this.state.pro.services[0].related_golf_course[0].id,
                }
              });
              this._dateSelected(this.state.selectedDate || moment().add(1, 'days'));
            } catch(e) { }
          });
        });
    })
  };

  _handleNext = () => {
    this._dateSelected(moment(this.state.selectedDate).add(1, 'days'));
  };

  _handlePrev = () => {
    if (this.state.selectedDate.isAfter(moment(), 'day')) {
      this._dateSelected(moment(this.state.selectedDate).subtract(1, 'days'));
    }
  };

  _dateSelected = (date) => {
    const {
      pro: {
        location_id = undefined,
        calendar_uid = undefined,
      } = {}
    } = this.props

    this.setState({ isLoading: true }, () => {
      this.setState({
        selectedDate: date
      }, () => {
        this.bookingService
          .getAvailabilityForDate(this.state.selectedService, this.state.selectedDate, this.state.services[this.state.selectedService], location_id, calendar_uid)
          .then(response => {

            const {
              times,
              noTeachingForDate
            } = response;

            this.setState({ times, noTeachingForDate, isLoading: false });
          });
      });
    });
  };

  _dateSelectedFromCalendar = (date) => {
    this._scrollToTimesList();
    this._dateSelected(date);
  };

  _onMonthChange = (month) => {
    this.setState({ month }, () => {
      this._updateCalendar();
    });
  };

  _updateCalendar() {
    const {
      pro: {
        location_id = undefined,
        calendar_uid = undefined,
      } = {}
    } = this.props

    const {
      selectedService,
      month
    } = this.state

    if(!selectedService){
      return
    }

    this.setState({ isLoading: true }, () => {

      this.bookingService
        .getAvailabilitiesForMonth(selectedService, month, location_id, calendar_uid)
        .then(data => {

          const {
            blockedDates
          } = data;

          this.setState({ blockedDates, isLoading: false }, () => {
            if (this.state.selectedDate) {
              this._dateSelected(this.state.selectedDate);
            }
          });
        })
    });
  }

  _proLocationChanged = (val) => {

    const fieldId = val.target.value;

    if (fieldId === '') {
      this.setState({ fieldId });
    } else {
      let fieldServices = [];

      for (const service of this.state.pro.services) {
        if ('related_golf_course' in service && service.related_golf_course.length && service.related_golf_course[0].id === fieldId) {
          let idx = 0;
          for (const type of service.service_types) {
            const stateService = this.state.services[parseInt(type.service_id, 10)];
            if (stateService) {
              fieldServices.push({
                name: stateService.name,
                value: type.service_id,
                id: idx++
              });
            }
          }
        }
      }

      this.setState({ fieldId, fieldServices }, () => {
        this._serviceChanged({ target: fieldServices[0] });
      });
    }
  };

  _serviceChanged = (val) => {

    const selectedService = val.target.value;

    this.setState({ selectedService }, () => {
      this._updateCalendar();
    });
  };

  _printFieldOptions(prefix='') {

    let idx = 1;
    let options = [];

    if (this.state.pro && this.state.pro.services) {

      const services = this.state.pro.services;

      for (const service of services) {
        if('related_golf_course' in service && service.related_golf_course.length){
          options.push({
            name: service.related_golf_course[0].label,
            value: service.related_golf_course[0].id,
            id: ++idx
          });
        }
      }
    }

    return options
  };

  /*
    Print field selection
   */
  _printFieldSelect() {
    const { isLoading } = this.state;
    const { localized } = this.props;
    const prefix = `${localized('lesson_booking.calendar.course')}: `;
    const opts = this._printFieldOptions(prefix);
    if(!opts.length){
      return null
    }

    return (
      <ThemeProvider theme={colors}>
        <ProsSelectorContainer disabled={isLoading}>
          {opts.map(this._printFieldSelectItem)}
        </ProsSelectorContainer>
      </ThemeProvider>
    );
  }

  _printFieldSelectItem = (fieldItem, idx) => {
    const { localized } = this.props;
    const {
      fieldId,
      isLoading,
    } = this.state;
    const {
      name,
      value
    } = fieldItem;

    const prefix = `${localized('lesson_booking.calendar.course')}: `;

    return (
      <ProsSelectorItem
        key={idx}
        className={value === fieldId ? 'selected' : ''}
        disabled={isLoading}
        onClick={() => this._proLocationChanged({ target: { value } })}
        title={`${prefix}${name}`}
      >
        <ProSelectorItemContent>
          <ProsSelectorName>
            {name}
          </ProsSelectorName>
        </ProSelectorItemContent>
        <ProSelectorActiveBar/>
      </ProsSelectorItem>
    );
  }

  _printServiceSelect() {
    const { localized } = this.props;
    const prefix = `${localized('lesson_booking.calendar.service')}: `
    let options = null;

    if (this.state.fieldServices) {
      options = this.state.fieldServices.map(service => {
        return (
          <option key={service.id} value={service.value}>{`${prefix}${service.name}`}</option>
        )
      });
    }
    if(!options || !options.length){
      return null
    }

    return (
      <div>
        <CalendarSelectLabel>
          <Select disabled={this.state.isLoading} onChange={this._serviceChanged}>
            { options }
          </Select>
        </CalendarSelectLabel>
      </div>
    );
  }

  /*
    Print availability info if selected date cannot be reserved
   */
  _printAvailabilityNotification(isAssistant = false) {
    const { localized } = this.props;

    if (this.state.noTeachingForDate || isAssistant) {
      return (
        <NoAvailableTimes>
          { localized('lesson_booking.calendar.no_teaching_for_selected_date') }
        </NoAvailableTimes>
      );
    } else {
      return null;
    }
  }

  _printCalendarComponent() {
    return (
      <CalendarWithSelection
        className={media.tabletNarrow ? 'full-width' : null}
        onDateSelected={this._dateSelectedFromCalendar}
        selectedDate={this.state.selectedDate}
        currentMonth={this.state.month}
        blockedDates={this.state.blockedDates}
        onMonthChange={this._onMonthChange}
        innerRef={(node) => { if(node) this.timesList = node; }}
      />
    );
  }

  _scrollToTimesList = () => {
    if(!this.timesList) return;
    if (window.innerHeight < 768) {
      this.timesList.scrollIntoView({behavior:'smooth'});
    }
  };

  _renderLoadingContainer() {
    return (
      <CalendarLoaderContainer isLoading={this.state.isLoading}>
        <LoaderWrapper>
          <LoaderSVG viewBox="-4 -4 24 24">
            <circle cx="8" cy="8" r="8"></circle>
          </LoaderSVG>
        </LoaderWrapper>
      </CalendarLoaderContainer>
    );
  }

  _renderTimeList() {
    return (
      <TimeList
        selectedMonth={this.state.month}
        times={this.state.times}
        date={this.state.selectedDate}
        handlePrev={this._handlePrev}
        handleNext={this._handleNext}
        twoCol={this.props.twoCol}
        pro={this.props.pro}
        location={this.props.location}
      />
    );
  }

  _renderDefaultVersion() {
    const {
      pro: {
        calendar_uid = undefined,
      } = {}
    } = this.props;
    const isAssistant = parseInt(calendar_uid, 10) === 27150
    return (
      <CalendarWrapper>
        {/* Field select is disabled until one pro model can hold more than one field */}
        { !Boolean(this.props.selectablePros) && this._printFieldSelect() }
        <CalendarSection className={'calendar-left-col'}>
          { this._printCalendarComponent() }
        </CalendarSection>
        <VirtualCalendarScroller innerRef={(node) => { if(node) this.timesList = node; }}></VirtualCalendarScroller>
        <CalendarSection className={'calendar-right-col'}>
          { this._printServiceSelect() }
          { !isAssistant && this._renderTimeList() }
          { this._printAvailabilityNotification(isAssistant) }
        </CalendarSection>
        { this._renderLoadingContainer() }
      </CalendarWrapper>
    );
  }

  _renderWidgetVersion() {
    return (
      <CalendarWrapper>
        {/* Field select is disabled until one pro model can hold more than one field */}
        { !Boolean(this.props.selectablePros) && this._printFieldSelect() }
        <CalendarSection className={'calendar-left-col'}>
          { this._printCalendarComponent() }
        </CalendarSection>
        <VirtualCalendarScroller innerRef={(node) => { if(node) this.timesList = node; }}></VirtualCalendarScroller>
        <CalendarSection className={'calendar-right-col'}>
          { this._printServiceSelect() }
          { this._renderTimeList() }
          { this._printAvailabilityNotification() }
        </CalendarSection>
        { this._renderLoadingContainer() }
      </CalendarWrapper>
    );
  }

  render() {
    const { location } = this.props;
    const isEmbed = location.pathname.match(/^\/embed\/(.*)/);
    if (isEmbed) {
      return this._renderWidgetVersion();
    } else {
      return this._renderDefaultVersion();
    }
  }
}

export default withLocalized(ProCalendar);



// WEBPACK FOOTER //
// ./src/modules/pros/components/ProCalendar.js